import { render, staticRenderFns } from "./addHzDw.vue?vue&type=template&id=72382a1c&scoped=true&"
import script from "./addHzDw.vue?vue&type=script&lang=js&"
export * from "./addHzDw.vue?vue&type=script&lang=js&"
import style0 from "./addHzDw.vue?vue&type=style&index=0&id=72382a1c&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72382a1c",
  null
  
)

export default component.exports